import { Pipe, PipeTransform } from '@angular/core';
import { CommonRiskModels } from '@wz-models';
import { prettyFullName } from '@wz-utilities/wz-utilities';
import { CommonModels } from '../../../../models/common.models';
import { ResourcesService } from '../../tunnelsante/services/resources/resources.service';

@Pipe({ name: 'fullName', standalone: false })
export class FullNamePipe implements PipeTransform {
  constructor(private resService: ResourcesService) {}

  transform(
    person: EngPerson | FrPerson | CommonRiskModels.AssureInfos,
  ): string {
    if (!isCommonRisk(person) && isEng(person)) {
      return prettyFullName(this.resService, {
        civility: person.civility,
        firstName: person.firstName,
        lastName: person.lastName,
      });
    } else if (isCommonRisk(person)) {
      return prettyFullName(this.resService, {
        civility: person.civilite,
        firstName: person.prenom!,
        lastName: person.nom!,
      });
    } else {
      return prettyFullName(this.resService, {
        civility: person.civility,
        firstName: person.prenom,
        lastName: person.nom,
      });
    }
  }
}

interface EngPerson {
  civility?: CommonModels.CivilityEnum;
  firstName: string;
  lastName: string;
}

interface FrPerson {
  civility?: CommonModels.CivilityEnum;
  prenom: string;
  nom: string;
}

function isEng(person: EngPerson | FrPerson): person is EngPerson {
  return (<EngPerson>person).firstName !== undefined;
}

function isCommonRisk(
  person: EngPerson | FrPerson | CommonRiskModels.AssureInfos,
): person is CommonRiskModels.AssureInfos {
  return (<CommonRiskModels.AssureInfos>person).prenom !== undefined;
}
